import { generateUniqueId } from "../lib/functions";

export const traded = [
  // Forex Pairs
  { pair: "AUDCAD", id: generateUniqueId() },
  { pair: "AUDCHF", id: generateUniqueId() },
  { pair: "AUDJPY", id: generateUniqueId() },
  { pair: "AUDNZD", id: generateUniqueId() },
  { pair: "AUDUSD", id: generateUniqueId() },
  { pair: "CADCHF", id: generateUniqueId() },
  { pair: "CADJPY", id: generateUniqueId() },
  { pair: "CHFJPY", id: generateUniqueId() },
  { pair: "EURAUD", id: generateUniqueId() },
  { pair: "EURCAD", id: generateUniqueId() },
  { pair: "EURCHF", id: generateUniqueId() },
  { pair: "EURGBP", id: generateUniqueId() },
  { pair: "EURJPY", id: generateUniqueId() },
  { pair: "EURNZD", id: generateUniqueId() },
  { pair: "EURUSD", id: generateUniqueId() },
  { pair: "GBPAUD", id: generateUniqueId() },
  { pair: "GBPCAD", id: generateUniqueId() },
  { pair: "GBPCHF", id: generateUniqueId() },
  { pair: "GBPJPY", id: generateUniqueId() },
  { pair: "GBPNZD", id: generateUniqueId() },
  { pair: "GBPUSD", id: generateUniqueId() },
  { pair: "NZDCAD", id: generateUniqueId() },
  { pair: "NZDCHF", id: generateUniqueId() },
  { pair: "NZDJPY", id: generateUniqueId() },
  { pair: "NZDUSD", id: generateUniqueId() },
  { pair: "USDCAD", id: generateUniqueId() },
  { pair: "USDCHF", id: generateUniqueId() },
  // { pair: "USDJPY", id:generateUniqueId() },
  // { pair: "AUDSGD", id:generateUniqueId() },
  { pair: "CADSGD", id: generateUniqueId() },
  { pair: "CHFSGD", id: generateUniqueId() },
  { pair: "EURAED", id: generateUniqueId() },
  { pair: "EURCZK", id: generateUniqueId() },
  { pair: "EURDKK", id: generateUniqueId() },
  { pair: "EURHKD", id: generateUniqueId() },
  { pair: "EURHUF", id: generateUniqueId() },
  { pair: "EURILS", id: generateUniqueId() },
  { pair: "EURINR", id: generateUniqueId() },
  { pair: "EURMXN", id: generateUniqueId() },
  { pair: "EURNOK", id: generateUniqueId() },
  { pair: "EURPLN", id: generateUniqueId() },
  { pair: "EURRON", id: generateUniqueId() },
  { pair: "EURRUB", id: generateUniqueId() },
  { pair: "EURSEK", id: generateUniqueId() },
  { pair: "EURSGD", id: generateUniqueId() },
  { pair: "EURTRY", id: generateUniqueId() },
  { pair: "EURZAR", id: generateUniqueId() },
  { pair: "GBPAED", id: generateUniqueId() },
  { pair: "GBPCZK", id: generateUniqueId() },
  { pair: "GBPDKK", id: generateUniqueId() },
  { pair: "GBPHKD", id: generateUniqueId() },
  { pair: "GBPHUF", id: generateUniqueId() },
  { pair: "GBPINR", id: generateUniqueId() },
  { pair: "GBPMXN", id: generateUniqueId() },
  { pair: "GBPNOK", id: generateUniqueId() },
  { pair: "GBPPLN", id: generateUniqueId() },
  { pair: "GBPRON", id: generateUniqueId() },
  { pair: "GBPRUB", id: generateUniqueId() },
  { pair: "GBPSEK", id: generateUniqueId() },
  { pair: "GBPSGD", id: generateUniqueId() },
  { pair: "GBPTRY", id: generateUniqueId() },
  { pair: "GBPZAR", id: generateUniqueId() },
  { pair: "NZDSGD", id: generateUniqueId() },
  { pair: "SGDJPY", id: generateUniqueId() },
  { pair: "USDCNH", id: generateUniqueId() },
  { pair: "USDCZK", id: generateUniqueId() },
  { pair: "USDDKK", id: generateUniqueId() },
  { pair: "USDHKD", id: generateUniqueId() },
  { pair: "USDHUF", id: generateUniqueId() },
  { pair: "USDILS", id: generateUniqueId() },
  { pair: "USDINR", id: generateUniqueId() },
  { pair: "USDMXN", id: generateUniqueId() },
  { pair: "USDNOK", id: generateUniqueId() },
  { pair: "USDPLN", id: generateUniqueId() },
  { pair: "USDRON", id: generateUniqueId() },
  { pair: "USDRUB", id: generateUniqueId() },
  { pair: "USDSEK", id: generateUniqueId() },
  { pair: "USDSGD", id: generateUniqueId() },
  { pair: "USDTHB", id: generateUniqueId() },
  { pair: "USDTRY", id: generateUniqueId() },
  { pair: "USDZAR", id: generateUniqueId() },
  { pair: "AUDHKD", id: generateUniqueId() },
  { pair: "AUDMXN", id: generateUniqueId() },
  { pair: "AUDNOK", id: generateUniqueId() },
  { pair: "AUDPLN", id: generateUniqueId() },
  { pair: "AUDSEK", id: generateUniqueId() },
  { pair: "AEDJPY", id: generateUniqueId() },
  { pair: "AUDCZK", id: generateUniqueId() },
  { pair: "AUDDKK", id: generateUniqueId() },
  { pair: "CHFAUD", id: generateUniqueId() },
  { pair: "CHFDKK", id: generateUniqueId() },
  { pair: "CHFSEK", id: generateUniqueId() },
  { pair: "DKKAUD", id: generateUniqueId() },
  { pair: "DKKCHF", id: generateUniqueId() },
  { pair: "HKDAUD", id: generateUniqueId() },
  { pair: "HKDJPY", id: generateUniqueId() },
  { pair: "INRAUD", id: generateUniqueId() },
  { pair: "INRJPY", id: generateUniqueId() },
  { pair: "JPYAUD", id: generateUniqueId() },
  { pair: "JPYHKD", id: generateUniqueId() },
  { pair: "JPYINR", id: generateUniqueId() },
  { pair: "MXNAUD", id: generateUniqueId() },
  { pair: "MXNJPY", id: generateUniqueId() },
  { pair: "NOKAUD", id: generateUniqueId() },
  { pair: "NOKJPY", id: generateUniqueId() },
  { pair: "NZDCAD", id: generateUniqueId() },
  { pair: "NZDCHF", id: generateUniqueId() },
  { pair: "NZDCZK", id: generateUniqueId() },
  { pair: "NZDDKK", id: generateUniqueId() },
  { pair: "NZDHKD", id: generateUniqueId() },
  { pair: "NZDILS", id: generateUniqueId() },
  { pair: "NZDINR", id: generateUniqueId() },
  { pair: "NZDMXN", id: generateUniqueId() },
  { pair: "NZDNOK", id: generateUniqueId() },
  { pair: "NZDPLN", id: generateUniqueId() },
  { pair: "NZDSEK", id: generateUniqueId() },
  { pair: "NZDSGD", id: generateUniqueId() },
  { pair: "NZDTHB", id: generateUniqueId() },
  { pair: "NZDTRY", id: generateUniqueId() },
  { pair: "NZDZAR", id: generateUniqueId() },
  { pair: "SEKAUD", id: generateUniqueId() },
  { pair: "SEKJPY", id: generateUniqueId() },
  { pair: "SGDAUD", id: generateUniqueId() },
  { pair: "SGDCHF", id: generateUniqueId() },
  { pair: "SGDJPY", id: generateUniqueId() },
  { pair: "THBAUD", id: generateUniqueId() },
  { pair: "THBJPY", id: generateUniqueId() },
  { pair: "TRYJPY", id: generateUniqueId() },
  { pair: "USDHUF", id: generateUniqueId() },
  { pair: "USDILS", id: generateUniqueId() },
  { pair: "USDJPY", id: generateUniqueId() },
  { pair: "USDMXN", id: generateUniqueId() },
  { pair: "USDPLN", id: generateUniqueId() },
  { pair: "USDSEK", id: generateUniqueId() },
  { pair: "USDTHB", id: generateUniqueId() },
  { pair: "USDTRY", id: generateUniqueId() },
  { pair: "USDZAR", id: generateUniqueId() },
  { pair: "ZARJPY", id: generateUniqueId() },

  // Indices
  { pair: "US30", id: generateUniqueId() }, // Dow Jones Industrial Average
  { pair: "SPX500", id: generateUniqueId() }, // S&P 500
  { pair: "NAS100", id: generateUniqueId() }, // Nasdaq 100
  { pair: "GER30", id: generateUniqueId() }, // DAX 30
  { pair: "UK100", id: generateUniqueId() }, // FTSE 100
  { pair: "JP225", id: generateUniqueId() }, // Nikkei 225
  { pair: "AUS200", id: generateUniqueId() }, // ASX 200
  { pair: "CAC40", id: generateUniqueId() }, // CAC 40
  { pair: "HK50", id: generateUniqueId() }, // Hang Seng Index
  { pair: "ES35", id: generateUniqueId() }, // IBEX 35
  { pair: "IT40", id: generateUniqueId() }, // FTSE MIB
  { pair: "CH20", id: generateUniqueId() }, // Swiss Market Index

  // Metals
  { pair: "XAGUSD", id: generateUniqueId() }, // Silver
  { pair: "XPTUSD", id: generateUniqueId() }, // Platinum
  { pair: "XAUUSD", id: generateUniqueId() }, // Gold
  { pair: "XPDUSD", id: generateUniqueId() }, // Palladium
  { pair: "XAUEUR", id: generateUniqueId() }, // Gold/EUR
  { pair: "XAGEUR", id: generateUniqueId() }, // Silver/EUR
  { pair: "XAUGBP", id: generateUniqueId() }, // Gold/GBP
  { pair: "XAGGBP", id: generateUniqueId() }, // Silver/GBP
  { pair: "XAUJPY", id: generateUniqueId() }, // Gold/JPY
  { pair: "XAGJPY", id: generateUniqueId() }, // Silver/JPY
];
